<p-table
  #dt1
  [value]="partners"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. partnera od ukupno {totalRecords}"
  [globalFilterFields]="['company', 'contact']"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-start">
      <div class="grid w-100">
        <div class="col-5">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              class="w-100"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Pretraži ime kompanije, osobu..."
            />
          </span>
        </div>
      </div>

      <div class="btn-group">
        <a
          [routerLink]="['add']"
          class="main-btn add-new-btn"
        >Dodaj partnera <i class="pi pi-plus"></i></a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="id">
        <div class="flex justify-content-between align-items-center">
          Kompanija
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Kontakt osoba
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Adresa
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">Email</div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Telefon
        </div>
      </th>
      <th style="width: 8rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-partner
  >
    <tr>
      <td>
        <span>{{ partner.company }}</span>
      </td>
      <td>
        <span>{{ partner.contact }}</span>
      </td>
      <td>
        <span>{{ partner.address }}</span>
      </td>
      <td>
        <span>{{ partner.email }}</span>
      </td>
      <td>
        <span>{{ partner.phone }}</span>
      </td>
      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          (click)="onEditPartner(partner)"
          [routerLink]="['edit']"
        >
          <i class="pi pi-pencil"></i>
        </a>
        <button
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeletePartner($event, partner.id)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">Ni jedan partner nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
